import { css } from "@emotion/react";

const animatedInFactory = (delayMs: number) => css`
  opacity: 0;
  transform: translateY(-1em);
  transition: opacity 0.65s ease, transform 0.65s ease;
  transition-delay: ${delayMs}ms;

  &.triggered {
    opacity: 1;
    transform: translate(0);
  }
`;

export const ANIMATED = {
  zero: animatedInFactory(1),
  veryFast: animatedInFactory(100),
  fast: animatedInFactory(300),
  medium: animatedInFactory(500),
  slow: animatedInFactory(700),
  verySlow: animatedInFactory(900),
};
